export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-latin-ext-700-normal.woff2?374879e924745eef9bfcf826f1cdc451";